var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "email-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "email-input",
    class: {
      mb: _vm.mb,
      changeb: _vm.email
    },
    attrs: {
      "id": "emailInput",
      "autocomplete": "off",
      "name": "emailInput",
      "placeholder": _vm.$t(_vm.$loginLangPrefix('userSign.phEmailTips'))
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }, _vm.emailInput],
      "blur": _vm.emailBlur
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "delete",
    class: {
      mb: _vm.mb
    },
    on: {
      "click": function click($event) {
        return _vm.deleteInput();
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };